<mat-tree
	[dataSource]="dataSource"
	[treeControl]="treeControl"
	cdkDropList
	(cdkDropListDropped)="onItemDrop($event)"
	>

	<mat-tree-node [class]="getObsolete(node.entity) ? 'obsolete' : ''"
		*matTreeNodeDef="let node"
		cdkDrag
		[cdkDragData]="node"
		>

		<div class="node-padding" *ngFor="let i of [].constructor(node.level)"></div>

		<div class="icon-wrapper">
			<mat-icon *ngIf="!(node.expandable)">radio_button_unchecked</mat-icon>
			<mat-icon *ngIf="node.expandable" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.filename" class="mat-icon-rtl-mirror">{{treeControl.isExpanded(node) ? 'remove_circle_outline' : 'add_circle_outline'}}</mat-icon>
		</div>

		<div (contextmenu)="onRightClick($event, node)">
			{{ getLabel(node.entity) }}
			<em *ngIf="contextDescGetter">&nbsp;({{ getContextDesc(node.entity) }})</em>
		</div>

	</mat-tree-node>
</mat-tree>

<div style="visibility: hidden; position: fixed;"
	[style.left]="contextMenuPosition.x"
	[style.top]="contextMenuPosition.y"
	[matMenuTriggerFor]="contextMenu"
	>
</div>

<mat-menu #contextMenu="matMenu">
	<!-- Servira peut-etre plus tard: exemple de bouton d'action reserve aux categories -->
	<!--
	<button *ngIf="contextMenuItem && contextMenuItem.expandable" mat-menu-item>
		<mat-icon>dialpad</mat-icon>
		<span>{{contextMenuItem.entity.id}}</span>
	</button>
	-->
	<button mat-menu-item (click)="onModifyClick($event, contextMenuItem)" *ngIf="!isObsolete(contextMenuItem)">
		<mat-icon>create</mat-icon>
		<span>Modifier</span>
	</button>
	<button mat-menu-item (click)="onArchiveClick($event, contextMenuItem)" *ngIf="!isObsolete(contextMenuItem)">
		<mat-icon>archive</mat-icon>
		<span>Désactiver</span>
	</button>
	<button mat-menu-item (click)="onDeleteClick($event, contextMenuItem)" *ngIf="!isObsolete(contextMenuItem)">
		<mat-icon>delete_outline</mat-icon>
		<span>Supprimer</span>
	</button>
	<button mat-menu-item (click)="onUnarchiveClick($event, contextMenuItem)" *ngIf="isObsolete(contextMenuItem)">
		<mat-icon>unarchive</mat-icon>
		<span>Activer</span>
	</button>
</mat-menu>